import React from 'react';
import shortid from 'shortid';
import CopyButton from '../utils/CopyButton';
import { parseTypeArrayOrObjectADRToCopy } from '../utils/parseADRToCopyUtils';

const DefaultTypeArray = props => {
  const {
    children,
    schema,
    path = [],
    enableCopyField,
    customCopyFieldComponent,
    displaySchema,
    rootProps,
  } = props;

  /* Don't show the copy button for a section without a title until we can
  highlight the entire section in the UI, otherwise it looks confusing
  */
  const copyableText = parseTypeArrayOrObjectADRToCopy(
    schema,
    props.ownData,
    false,
    path,
    { displaySchema, ownProps: rootProps },
  );

  return (
    <div className={`default-type-array depth-${path.length}`}>
      {schema.title && (
        <div className="default-type-array-title">
          <strong className="default-type-title">{schema.title}</strong>
          {enableCopyField && (
            <CopyButton
              key={shortid.generate()}
              text={copyableText}
              customButton={customCopyFieldComponent}
            />
          )}
        </div>
      )}

      <div className="default-type-array-children">
        {children.map((child, idx) => (
          <div key={shortid.generate()} className="default-type-array-item">
            {schema && schema.items && schema.items.title && (
              <div className="default-type-array-item-title">
                <strong className="default-type-title">
                  {`${schema.items.title} ${idx + 1}`}
                </strong>
              </div>
            )}
            <div className="default-type-array-item-value">{child}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DefaultTypeArray;
